(() => {
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-or-copy-promo]');
    if (!button) return;

    const code = button.dataset.orCopyPromo;
    if (!code) return;

    const label = button.querySelector('small');
    const originalLabel = label?.textContent || '';

    try {
      await navigator.clipboard.writeText(code);
      if (label) label.textContent = 'Copiado';
    } catch (_error) {
      if (label) label.textContent = 'Código';
    }

    window.setTimeout(() => {
      if (label) label.textContent = originalLabel;
    }, 1800);
  });
})();
